import styled from 'styled-components';
import Typography from './Typography';
import { TypographyVariant } from './Typography.decl';
var Link = styled(Typography).withConfig({
  displayName: "Link",
  componentId: "sc-1ca6ll-0"
})(["display:inline;background-color:transparent;text-decoration:none;outline:none;cursor:pointer;&:hover{text-decoration:underline;}"]);
Link.defaultProps = {
  as: 'a',
  color: 'primary.base',
  variant: TypographyVariant.BODY
};
export default Link;